import { Typography, Box, Skeleton, Stack, Chip } from '@mui/material';

const STATUS_STYLES = {
  success: { bgcolor: '#e8f5e9', color: '#2e7d32' },
  error: { bgcolor: '#ffebee', color: '#c62828' },
  warning: { bgcolor: '#fff8e1', color: '#f57f17' },
  neutral: { bgcolor: '#f5f5f5', color: '#616161' },
};

const resolveStatus = (content, variant) => {
  if (variant) return variant;

  if (typeof content === 'boolean') {
    return content ? 'error' : 'success';
  }

  if (typeof content === 'string') {
    const value = content.toUpperCase();
    if (value === 'DELIVERABLE' || value === 'FALSE' || value === 'ACTIVE') {
      return 'success';
    }
    if (value === 'RISKY') return 'warning';
    if (value === 'UNDELIVERABLE' || value === 'BANNED' || value === 'TRUE') {
      return 'error';
    }
  }

  return null;
};

const formatValue = (content) => {
  if (typeof content === 'boolean') {
    return content ? 'Yes' : 'No';
  }
  if (content === null || content === undefined || content === '') {
    return '—';
  }
  return String(content);
};

const ContentContainer = ({ title, content, progress, variant, chipLabel }) => {
  if (progress) {
    return (
      <Box sx={{ py: 1 }}>
        <Skeleton variant="rounded" width="100%" height={40} />
      </Box>
    );
  }

  const status = resolveStatus(content, variant);
  const label = chipLabel || formatValue(content);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        py: 1.25,
        px: 0.5,
        borderBottom: '1px solid #eee',
        '&:last-child': { borderBottom: 'none' },
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', fontWeight: 500, flexShrink: 0 }}
      >
        {title}
      </Typography>

      {status ? (
        <Chip
          label={label}
          size="small"
          sx={{
            ...STATUS_STYLES[status],
            fontWeight: 600,
            borderRadius: '8px',
            maxWidth: '100%',
          }}
        />
      ) : (
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
            fontWeight: 600,
            textAlign: 'right',
            wordBreak: 'break-word',
          }}
        >
          {label}
        </Typography>
      )}
    </Stack>
  );
};

export default ContentContainer;
